module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page03"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page04"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Eminent Lives, brief biographies by distinguished authors on canonical figures, joins a long tradition in this lively form, from Plutarch’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives")]), _vm._v(" to Vasari’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives of the Painters,")]), _vm._v(" Dr. Johnson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives of the Poets")]), _vm._v(" to Lytton Strachey’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eminent Victorians")]), _vm._v(". Pairing great subjects with writers known for their strong sensibilities and sharp, lively points of view, the Eminent Lives are ideal introductions designed to appeal to the general reader, the student, and the scholar. “To preserve a becoming brevity which excludes everything that is redundant and nothing that is significant,” wrote Strachey: “That, surely, is the first duty of the biographer.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70285bd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thomasjefferson_fm01.vue
// module id = 69
// module chunks = 0